
import ic_instagram     from '../Images/ic_instagram.svg';
import img_logo         from '../Images/img_logo.svg'
import ic_apple_black   from '../Images/ic_apple_black.svg';
import img_app          from '../Images/img_app.png';
import pattern_home     from '../Images/pattern_home.svg';
import patternAll       from '../Images/pattern_all.svg';
import logo_black       from '../Images/logo_black.svg';
import ic_apple_white   from '../Images/ic_apple_white.svg';

export const imageBackground    = pattern_home
export const pattern_all        = patternAll

export const footerData = {
    text1:  '© 2020 Rayas Diseñadoras  -  Todos los derechos reservados',
    text2:  'Más información',
    text3:  'Politicas de privacidad',
    text4:  'Síguenos en Instagram',
    text5:  'Contacto',
    image:  img_logo,
    icon:   ic_instagram,
    link:   'https://www.instagram.com/rayas_disenadoras/?hl=es-la'
}

export const homeData = {
    image1: img_app,
    image2: img_logo,
    icon:   ic_apple_black,
    text1:  'Descarga nuestra app, encuentra la corbata que buscas.',
    button: 'App Store'
}

export const bannerData = {
    button: 'App Store',
    image:  logo_black,
    icon:   ic_apple_white
}

export const contactData = {
    title:  'Contacto',
    text1:  '¡Hola!',
    text2:  'Manda tus datos para que un asesor se ponga en contacto contigo.',
    text3:  'Mensaje',
    text4:  'Tu nombre',
    text5:  'Tu correo',
    button: 'Enviar'
}

export const privacy = {
    title:  'Políticas de privacidad',
}

export const urlApi    = ' https://us-central1-rayas-7cc67.cloudfunctions.net/rayas/'
export const path      = 'contact'